var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('banner',{attrs:{"type":"4"}}),_c('productList',{attrs:{"recommend-show":false,"product-list":_vm.customizedServicesList,"product-name":"定制服务"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }